import React, { useState } from 'react'
import { useParams } from 'react-router'

import HeaderTabLayout from '../../components/HeaderTabLayout'
import Layout from '../../components/Layout'
import Loader from '../../components/Loader'
import EditStateComp from '../../components/version-4/MasterForms/EditForms/EditStateComp'

import { useStates } from '../../hooks/CompanyConfiguration/useStates'
import { ROUTES } from '../../shared/constants'

function EditState() {
  const { states, getStates, updateStates } = useStates()
  const [statedata, setStatedata] = useState({
    stateCode: '',
    name: '',
    region: '',
    zone: '',
    active: '',
  })

  const params = useParams()

  React.useEffect(() => {
    getStates({ stateId: params.stateId })
  }, [params.stateId])

  React.useEffect(() => {
    if (states) {
      setStatedata({
        name: states.name,
        region: states.region && states.region._id,
        zone: states.zone && states.zone._id,
        stateCode: states.stateCode,
        active: states.active,
        stateId: params.stateId,
      })
    }
  }, [states])

  const handleState = () => {
    updateStates(statedata)
  }
  return (
    <Layout heading="State" heading2="Edit" url1={ROUTES.STATE} none>
      {states ? <HeaderTabLayout heading="Edit State" state={statedata} setState={setStatedata} content={<EditStateComp state={statedata} setState={setStatedata} />} addContent={handleState} redirect={ROUTES.STATE} /> : <Loader />}
    </Layout>
  )
}

export default EditState
